export enum SuperAdminPrivilege {
  roomInspector = 'roomInspector',
  canViewFeatureFlags = 'canViewFeatureFlags',
  canInvokeEmailTemplateHandler = 'canInvokeEmailTemplateHandler',

  // prompt related privileges
  canEditOutputPrompt = 'canEditOutputPrompt',
  canInstallPrompts = 'canInstallPrompts',
}
